/**
 * 首页展示的stem榜单类型
 */
export const stemTypesFromHome = [
  {
    name: 'ISTEM',
    value: 'INTERNATIONAl',
    order: 1,
    show: false
  },
  {
    name: '医学院校ASTEM',
    value: 'UNIVERSITY_ASTEM',
    order: 3,
    show: true
  },
  {
    name: '医学院校STEM',
    value: 'UNIVERSITY',
    order: 2,
    show: true
  },
  {
    name: '医院ASTEM(综合)',
    value: 'HOSPITAL_ASTEM',
    show: true,
    order: 5
  },
  {
    name: '医院STEM(综合)',
    value: 'HOSPITAL',
    order: 4,
    show: true
  }
]

export const filedMappings = {
  international: 'INTERNATIONAl',
  hospital_astem: 'HOSPITAL_ASTEM',
  hospital: 'HOSPITAL',
  college: 'UNIVERSITY',
  college_astem: 'UNIVERSITY_ASTEM',
  hightLight: 'HIGH_LIGHT'
}
